import { jsx as _jsx } from "react/jsx-runtime";
import { ProgramDetail } from "../../../Orders/OrderDetailsAccordion/ProgramComponents/ProgramDetail";
import { SubscriptionsTexts } from "../../subscriptionsUtils/constsAndEnums";
import { Grid } from "@mui/material";
export const Sub_BillingDetails = ({ ccText }) => {
    return (_jsx(Grid, Object.assign({ item: true, xx: 12, sm: 4 }, { children: _jsx(Grid, Object.assign({ container: true, spacing: 2 }, { children: _jsx(ProgramDetail, { detailName: SubscriptionsTexts.BILLING, detailValue: ccText, xx: 12, sm: 12, md: 12 }) })) })));
};
